'use strict';
window.theme = window.theme || {};
window.Shopify = window.Shopify || {};
theme.Sections = function() {
  this.constructors = {};
  this.instances = [];
  document.addEventListener("shopify:section:load", this._onSectionLoad.bind(this));
  document.addEventListener("shopify:section:unload", this._onSectionUnload.bind(this));
  document.addEventListener("shopify:section:select", this._onSelect.bind(this));
  document.addEventListener("shopify:section:deselect", this._onDeselect.bind(this));
  document.addEventListener("shopify:block:select", this._onBlockSelect.bind(this));
  document.addEventListener("shopify:block:deselect", this._onBlockDeselect.bind(this));
};
theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {_createInstance:function(n, k, q) {
  var r = n.getAttribute("data-section-id"), b = n.getAttribute("data-section-type");
  k = k || this.constructors[b];
  "undefined" !== typeof k && (q && this._findInstance(r) && this._removeInstance(r), n = Object.assign(new k(n), {id:r, type:b, container:n}), this.instances.push(n));
}, _findInstance:function(n) {
  for (var k = 0; k < this.instances.length; k++) {
    if (this.instances[k].id === n) {
      return this.instances[k];
    }
  }
}, _removeInstance:function(n) {
  for (var k = this.instances.length, q; k--;) {
    if (this.instances[k].id === n) {
      q = this.instances[k];
      this.instances.splice(k, 1);
      break;
    }
  }
  return q;
}, _onSectionLoad:function(n, k, q) {
  theme && theme.initGlobals && theme.initGlobals();
  var r = k ? k : n.target, b = k ? k : n.target.querySelector("[data-section-id]");
  if (b) {
    this._createInstance(b);
    k = k ? q : this._findInstance(n.detail.sectionId);
    r.querySelectorAll("[data-subsection]").length && this.loadSubSections(r);
    if (k && "function" === typeof k.onLoad) {
      k.onLoad(n);
    }
    setTimeout(function() {
      window.dispatchEvent(new Event("scroll"));
    }, 200);
  }
}, _onSectionUnload:function(n) {
  this.instances = this.instances.filter(function(k) {
    var q = k.id === n.detail.sectionId;
    if (q && "function" === typeof k.onUnload) {
      k.onUnload(n);
    }
    return !q;
  });
}, loadSubSections:function(n) {
  (n ? n.querySelectorAll("[data-subsection]") : document.querySelectorAll("[data-subsection]")).forEach(k => {
    this._onSectionLoad(null, k, k.dataset.sectionId);
  });
}, _onSelect:function(n) {
  var k = this._findInstance(n.detail.sectionId);
  if ("undefined" !== typeof k && "function" === typeof k.onSelect) {
    k.onSelect(n);
  }
}, _onDeselect:function(n) {
  var k = this._findInstance(n.detail.sectionId);
  if ("undefined" !== typeof k && "function" === typeof k.onDeselect) {
    k.onDeselect(n);
  }
}, _onBlockSelect:function(n) {
  var k = this._findInstance(n.detail.sectionId);
  if ("undefined" !== typeof k && "function" === typeof k.onBlockSelect) {
    k.onBlockSelect(n);
  }
}, _onBlockDeselect:function(n) {
  var k = this._findInstance(n.detail.sectionId);
  if ("undefined" !== typeof k && "function" === typeof k.onBlockDeselect) {
    k.onBlockDeselect(n);
  }
}, register:function(n, k, q) {
  this.constructors[n] = k;
  var r = document.querySelectorAll('[data-section-type="' + n + '"]');
  q && (r = q.querySelectorAll('[data-section-type="' + n + '"]'));
  r.forEach(function(b) {
    this._createInstance(b, k, q);
  }.bind(this));
}, reinit:function(n) {
  for (var k = 0; k < this.instances.length; k++) {
    var q = this.instances[k];
    q.type === n && "function" === typeof q.forceReload && q.forceReload();
  }
}});
theme.config = {bpSmall:!1, bpSmallValue:589, hasSessionStorage:!0, mediaQuerySmall:"screen and (max-width: 589px)", youTubeReady:!1, vimeoReady:!1, vimeoLoading:!1, isTouch:"ontouchstart" in window || window.DocumentTouch && window.document instanceof DocumentTouch || window.navigator.maxTouchPoints || window.navigator.msMaxTouchPoints ? !0 : !1, rtl:"rtl" == document.documentElement.getAttribute("dir") ? !0 : !1};
theme.recentlyViewedIds = [];
theme.config.isTouch && (document.documentElement.className += " supports-touch");
console && console.log && console.log("%c " + theme.settings.themeName + " theme (" + window.BOOMR.themeVersion + ") %c Learn more at https://stickyt.com/", "background: red; color: white; display: block; font-size: 15px;\u00a0padding:4px 6px 4px 0;border-radius:4px;line-height: 1.8;", "background: transparent; color: red; display: block;  font-size: 12px;");
window.lazySizesConfig = window.lazySizesConfig || {};
lazySizesConfig.expFactor = 2.2;
(function() {
  function n() {
    var b, a;
    return new Promise((c, e) => {
      b = setInterval(function() {
        Vimeo && (clearInterval(b), clearTimeout(a), c());
      }, 500);
      a = setTimeout(function() {
        clearInterval(b);
        e();
      }, 4000);
    });
  }
  theme.delegate = {on:function(b, a, c) {
    this.namespaces || (this.namespaces = {});
    this.namespaces[b] = a;
    c = c || !1;
    this.addEventListener(b.split(".")[0], a, c);
    return this;
  }, off:function(b) {
    if (this.namespaces) {
      return this.removeEventListener(b.split(".")[0], this.namespaces[b]), delete this.namespaces[b], this;
    }
  }};
  window.on = Element.prototype.on = theme.delegate.on;
  window.off = Element.prototype.off = theme.delegate.off;
  theme.Helpers = {defaultTo:function(b, a) {
    return null == b || b !== b ? a : b;
  }, wrap:function(b, a) {
    b.parentNode.insertBefore(a, b);
    a.appendChild(b);
  }, debounce:function(b, a, c) {
    var e;
    return function() {
      var g = this, d = arguments, f = c && !e;
      clearTimeout(e);
      e = setTimeout(function() {
        e = null;
        c || a.apply(g, d);
      }, b);
      f && a.apply(g, d);
    };
  }, throttle:function(b, a) {
    var c = !1;
    return function() {
      c || (a.apply(this, arguments), c = !0, setTimeout(function() {
        c = !1;
      }, b));
    };
  }, prepareTransition:function(b, a) {
    function c(e) {
      b.classList.remove("is-transitioning");
      b.removeEventListener("transitionend", c);
    }
    b && (b.addEventListener("transitionend", c), b.classList.add("is-transitioning"), this.drawerPath = b.offsetWidth, "function" === typeof a && a());
  }, compact:function(b) {
    for (var a = -1, c = null == b ? 0 : b.length, e = 0, g = []; ++a < c;) {
      var d = b[a];
      d && (g[e++] = d);
    }
    return g;
  }, serialize:function(b) {
    var a = [];
    Array.prototype.slice.call(b.elements).forEach(function(c) {
      !c.name || c.disabled || -1 < ["file", "reset", "submit", "button"].indexOf(c.type) || ("select-multiple" === c.type ? Array.prototype.slice.call(c.options).forEach(function(e) {
        e.selected && a.push(encodeURIComponent(c.name) + "=" + encodeURIComponent(e.value));
      }) : -1 < ["checkbox", "radio"].indexOf(c.type) && !c.checked || a.push(encodeURIComponent(c.name) + "=" + encodeURIComponent(c.value)));
    });
    return a.join("&");
  }};
  window.slate = window.slate || {};
  slate.a11y = {trapFocus:function(b) {
    var a = b.namespace ? "focusin." + b.namespace : "focusin", c = b.namespace ? "focusout." + b.namespace : "focusout", e = b.namespace ? "keydown." + b.namespace : "keydown.handleFocus", g = b.container.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])');
    g = [].slice.call(g).filter(h => null !== h.offsetParent);
    var d = g[0], f = g[g.length - 1];
    b.elementToFocus || (b.elementToFocus = b.container);
    b.container.setAttribute("tabindex", "-1");
    b.elementToFocus.focus();
    b.elementToFocus.scrollIntoView();
    document.documentElement.off("focusin");
    document.documentElement.on(c, function() {
      document.documentElement.off(e);
    });
    document.documentElement.on(a, function(h) {
      if (h.target === f || h.target === d) {
        document.documentElement.on(e, function(l) {
          9 === l.keyCode && l.target === d && l.shiftKey && (l.preventDefault(), f.focus());
        });
      }
    });
  }, removeTrapFocus:function(b) {
    var a = b.namespace ? "focusin." + b.namespace : "focusin";
    b.container && b.container.removeAttribute("tabindex");
    document.documentElement.off(a);
  }, lockMobileScrolling:function(b, a) {
    a = a ? a : document.documentElement;
    document.documentElement.classList.add("lock-scroll");
    a.on("touchmove" + b, function() {
      return !0;
    });
  }, unlockMobileScrolling:function(b, a) {
    document.documentElement.classList.remove("lock-scroll");
    (a ? a : document.documentElement).off("touchmove" + b);
  }};
  document.documentElement.on("keyup.tab", function(b) {
    9 === b.keyCode && (document.documentElement.classList.add("tab-outline"), document.documentElement.off("keyup.tab"));
  });
  theme.Currency = function() {
    var b = theme && theme.settings && theme.settings.superScriptPrice;
    return {formatMoney:function(a, c) {
      function e(f, h, l, m) {
        l = theme.Helpers.defaultTo(l, ",");
        m = theme.Helpers.defaultTo(m, ".");
        h = theme.Helpers.defaultTo(h, 2);
        if (isNaN(f) || null == f) {
          return 0;
        }
        f = (f / 100.0).toFixed(h);
        f = f.split(".");
        return f[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + l) + (f[1] ? m + f[1] : "");
      }
      "string" === typeof a && (a = a.replace(".", ""));
      c || (c = theme.settings.moneyFormat);
      var g = "", d = /\{\{\s*(\w+)\s*\}\}/;
      c = c || "${{amount}}";
      switch(c.match(d)[1]) {
        case "amount":
          g = e(a, 2);
          b && g && g.includes(".") && (g = g.replace(".", "<sup>") + "</sup>");
          break;
        case "amount_no_decimals":
          g = e(a, 0);
          break;
        case "amount_with_comma_separator":
          g = e(a, 2, ".", ",");
          b && g && g.includes(".") && (g = g.replace(",", "<sup>") + "</sup>");
          break;
        case "amount_no_decimals_with_comma_separator":
          g = e(a, 0, ".", ",");
          break;
        case "amount_no_decimals_with_space_separator":
          g = e(a, 0, " ");
      }
      return c.replace(d, g);
    }, getBaseUnit:function(a) {
      if (a && a.unit_price_measurement && a.unit_price_measurement.reference_value) {
        return 1 === a.unit_price_measurement.reference_value ? a.unit_price_measurement.reference_unit : a.unit_price_measurement.reference_value + a.unit_price_measurement.reference_unit;
      }
    }};
  }();
  theme.Images = function() {
    return {imageSize:function(b) {
      if (!b) {
        return "620x";
      }
      b = b.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);
      return null !== b ? b[1] : null;
    }, getSizedImageUrl:function(b, a) {
      if (!b || null == a) {
        return b;
      }
      if ("master" === a) {
        return this.removeProtocol(b);
      }
      var c = b.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
      return null != c ? (b = b.split(c[0]), this.removeProtocol(b[0] + "_" + a + c[0])) : null;
    }, removeProtocol:function(b) {
      return b.replace(/http(s)?:/, "");
    }, buildImagePath:function(b, a) {
      if (null == b) {
        return [];
      }
      if (a) {
        const c = [];
        a.forEach(e => {
          let g = `${b}?width=${e}`;
          g = e === a[a.length - 1] ? g + ` ${e}w` : g + ` ${e}w,`;
          c.push(g);
        });
        return c;
      }
      return [b];
    }};
  }();
  theme.initWhenVisible = function(b) {
    (new IntersectionObserver((a, c) => {
      a.forEach(e => {
        e.isIntersecting && "function" === typeof b.callback && (b.callback(), c.unobserve(e.target));
      });
    }, {rootMargin:"0px 0px " + (b.threshold ? b.threshold : 0) + "px 0px"})).observe(b.element);
  };
  theme.LibraryLoader = function() {
    function b(g, d) {
      var f = document.createElement("script");
      f.src = g.src;
      f.addEventListener("load", function() {
        g.status = c.loaded;
        d();
      });
      return f;
    }
    function a(g, d) {
      var f = document.createElement("link");
      f.href = g.src;
      f.rel = "stylesheet";
      f.type = "text/css";
      f.addEventListener("load", function() {
        g.status = c.loaded;
        d();
      });
      return f;
    }
    var c = {requested:"requested", loaded:"loaded"}, e = {youtubeSdk:{tagId:"youtube-sdk", src:"https://www.youtube.com/iframe_api", type:"script"}, vimeo:{tagId:"vimeo-api", src:"https://player.vimeo.com/api/player.js", type:"script"}, shopifyXr:{tagId:"shopify-model-viewer-xr", src:"https://cdn.shopify.com/shopifycloud/shopify-xr-js/assets/v1.0/shopify-xr.en.js", type:"script"}, modelViewerUi:{tagId:"shopify-model-viewer-ui", src:"https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.en.js", 
    type:"script"}, modelViewerUiStyles:{tagId:"shopify-model-viewer-ui-styles", src:"https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css", type:"link"}};
    return {load:function(g, d) {
      if ((g = e[g]) && g.status !== c.requested) {
        if (d = d || function() {
        }, g.status === c.loaded) {
          d();
        } else {
          g.status = c.requested;
          switch(g.type) {
            case "script":
              var f = b(g, d);
              break;
            case "link":
              f = a(g, d);
          }
          f.id = g.tagId;
          g.element = f;
          d = document.getElementsByTagName(g.type)[0];
          d.parentNode.insertBefore(f, d);
        }
      }
    }};
  }();
  slate.rte = function() {
    function b(a) {
      a.src = a.src;
      var c = document.createElement("div");
      c.classList.add("video-wrapper");
      theme.Helpers.wrap(a, c);
    }
    document.querySelectorAll(".rte table").forEach(a => {
      var c = document.createElement("div");
      c.classList.add("table-wrapper");
      theme.Helpers.wrap(a, c);
    });
    document.querySelectorAll('.rte iframe[src*="youtube.com/embed"]').forEach(a => {
      b(a);
    });
    document.querySelectorAll('.rte iframe[src*="player.vimeo"]').forEach(a => {
      b(a);
    });
    document.querySelectorAll(".rte a img").forEach(a => {
      a.parentNode.classList.add("rte__image");
    });
  };
  window.vimeoApiReady = function() {
    theme.config.vimeoLoading = !0;
    n().then(function() {
      theme.config.vimeoReady = !0;
      theme.config.vimeoLoading = !1;
      document.dispatchEvent(new CustomEvent("vimeoReady"));
    });
  };
  (function() {
    var b = Flickity.prototype.resize, a = window.innerWidth;
    Flickity.prototype.resize = function() {
      window.innerWidth !== a && (a = window.innerWidth, b.apply(this, arguments));
    };
  })();
  (function() {
    var b, a = !1;
    document.body.addEventListener("touchstart", function(c) {
      if (!c.target.closest(".flickity-slider")) {
        return a = !1;
      }
      a = !0;
      b = c.touches[0].pageX;
    });
    document.body.addEventListener("touchmove", function(c) {
      a && c.cancelable && Math.abs(c.touches[0].pageX - b) > Flickity.defaults.dragThreshold && c.preventDefault();
    }, {passive:!1});
  })();
  var k = "", q = "";
  theme.collapsibles = function() {
    function b(h) {
      var l = h.classList.contains(d.open);
      h.setAttribute("data-expanded", l);
      h.off("click.collapsible");
      h.on("click.collapsible", a);
      (l = Cookies.get("collapsible-trigger")) && (1 == g ? l == h.dataset.controls && a(null, l) : Cookies.set("collapsible-trigger", null));
    }
    function a(h, l) {
      if (!e) {
        e = !0;
        if (h) {
          h = h.currentTarget;
        } else if (l) {
          h = document.querySelector('button[data-controls="' + l + '"]');
        } else {
          return;
        }
        var m = h.classList.contains(d.open);
        l = h.getAttribute("data-controls");
        var p = document.getElementById(l);
        if ("Pickup-availability" == h.getAttribute("data-controls") && h.parentNode) {
          p = h.querySelector("#" + l);
          var t = h.parentNode.querySelector("[data-pickup-availability-button]");
          t.classList.contains(d.open) ? t.classList.remove(d.open) : t.classList.add(d.open);
        }
        if (!l && (l = h.dataset.controls, !l)) {
          return;
        }
        if (!p && (0 < document.querySelectorAll('[data-id="' + l + '"]').length && (p = h.parentNode.parentNode.querySelector('[data-id="' + l + '"]')), !p)) {
          e = !1;
          return;
        }
        p.querySelector(f.moduleInner).parentElement.classList.remove("hide");
        var u = p.querySelector(f.moduleInner).offsetHeight, v = p.classList.contains(d.autoHeight);
        l = p.parentNode.closest(f.module);
        t = u;
        m && v && setTimeout(function() {
          u = 0;
          c(p, u, m, v);
        }, 0);
        m && !v && (u = 0);
        h.setAttribute("data-expanded", !m);
        m ? (h.classList.remove(d.open), Cookies.set("collapsible-trigger", null)) : (h.classList.add(d.open), "" != q && k != h && (k.setAttribute("data-expanded", !m), k.classList.remove(d.open), c(q, 0, !0, !1)), k = h, q = p, Cookies.set("collapsible-trigger", h.dataset.controls));
        c(p, u, m, v);
        l && c(l, m ? l.offsetHeight - t : u + l.offsetHeight, !1, !1);
      }
    }
    function c(h, l, m, p) {
      h.classList.remove(d.hide);
      theme.Helpers.prepareTransition(h, function() {
        h.style.height = l + "px";
        m ? (h.classList.remove(d.open), window.setTimeout(function() {
          h.classList.add(d.hide);
        }, 500)) : h.classList.add(d.open);
      });
      !m && p ? window.setTimeout(function() {
        h.css("height", "auto");
        e = !1;
      }, 500) : e = !1;
    }
    var e = !1, g = !1, d = {hide:"hide", open:"is-open", autoHeight:"collapsible--auto-height"}, f = {trigger:".collapsible-trigger", module:".collapsible-content", moduleInner:".collapsible-content__inner"};
    return {init:function(h) {
      h = h ? h : document;
      -1 !== window.location.pathname.indexOf("/blogs/") && (g = !0);
      h.querySelectorAll(f.trigger).forEach(l => {
        b(l);
      });
    }, trigger:b};
  }();
  theme.Disclosure = function() {
    function b(a) {
      this.container = a;
      this._cacheSelectors();
      this._setupListeners();
    }
    b.prototype = Object.assign({}, b.prototype, {_cacheSelectors:function() {
      this.cache = {disclosureForm:this.container.closest("[data-disclosure-form]"), disclosureList:this.container.querySelector("[data-disclosure-list]"), disclosureToggle:this.container.querySelector("[data-disclosure-toggle]"), disclosureInput:this.container.querySelector("[data-disclosure-input]"), disclosureOptions:this.container.querySelectorAll("[data-disclosure-option]")};
    }, _setupListeners:function() {
      document.getElementById("FooterLocale");
    }});
    return b;
  }();
  theme.Slideshow = function() {
    function b(d, f, h) {
      d.id.includes("ProductPhotos-") ? g.setGallerySize = !1 : g.setGallerySize = !0;
      this.el = d;
      this.args = Object.assign({}, g, f);
      this.slideIndex = 0;
      this.args.on = {ready:this.init.bind(this), change:this.slideChange.bind(this), settle:this.afterChange.bind(this)};
      this.args.childNav && (this.childNavEls = this.args.childNav.querySelectorAll(e.thumb), this.childNavLinks = this.args.childNav.querySelectorAll(e.links), this.arrows = this.args.childNav.querySelectorAll(e.arrow), 2 > this.childNavEls.length && (this.args.pageDots = !1), this.childNavLinks.length && this.initChildNav());
      this.slideshow = new Flickity(d, this.args);
      this.args.autoPlay && (d = d.closest(c.wrapper), null != d && (this.pauseBtn = d.querySelector(c.pauseButton)) && this.pauseBtn.addEventListener("click", this._togglePause.bind(this)));
      var l = window.innerWidth;
      window.on("resize", theme.Helpers.debounce(300, function() {
        window.innerWidth != l && (l = window.innerWidth, this.resize());
      }.bind(this)));
      this.embeddedResize(0);
      null != this.slideshow.element.querySelector(".collapsible-trigger-btn") && this.slideshow.element.querySelectorAll(".collapsible-trigger-btn").forEach(m => {
        m.addEventListener("click", function(p) {
          this.resize();
          this.slideshow.resize();
        }.bind(this));
      });
    }
    function a(d, f) {
      var h = function(l) {
        setTimeout(function() {
          d.style.opacity = l;
        }, 1000 * l);
      };
      for (f = 0; 1 >= f; f += 0.01) {
        h(f);
      }
    }
    var c = {allSlides:".slideshow__slide", currentSlide:".is-selected", wrapper:".slideshow-wrapper", pauseButton:".slideshow__pause"}, e = {thumb:".product-single__thumbnail-item:not(.hide)", links:".product-single__thumbnail-item:not(.hide) a", arrow:".product-single__thumbnail-arrow"}, g = {adaptiveHeight:!1, autoPlay:!1, childNav:null, childNavScroller:null, childVertical:!1, dragThreshold:7, fade:!1, friction:0.8, initialIndex:0, pageDots:!1, pauseAutoPlayOnHover:!1, prevNextButtons:!1, rightToLeft:theme.config.rtl, 
    selectedAttraction:0.14, setGallerySize:!0, wrapAround:!0, arrowShape:"M 25 50 L 70 93 L 67 90 L 25 50 L 65 10 L 68 7 Z"};
    b.prototype = Object.assign({}, b.prototype, {init:function(d) {
      this.currentSlide = this.el.querySelector(c.currentSlide);
      if (this.args.callbacks && this.args.callbacks.onInit && "function" === typeof this.args.callbacks.onInit) {
        this.args.callbacks.onInit();
      }
    }, slideChange:function(d) {
      this.slideIndex = d;
      this.embeddedResize(this.slideIndex);
      this.el.classList.contains("hero") && this.el.parentElement.parentElement.querySelectorAll(".site-nav__dropdown-link").forEach((p, t) => {
        this.slideIndex == t ? p.classList.add("is-active") : p.classList.remove("is-active");
      });
      if ("splittedtexts" == this.el.parentElement.getAttribute("data-section-type")) {
        var f = this.el.id.replace(/\--/, "&").split("&")[1];
        if (null != document.querySelector("#SplittedImages--" + f)) {
          var h = document.querySelector("#ProductSection-" + f + d);
          null != h && "false" == h.dataset.generated && (h.dataset.generated = "true", this.Product = new theme.Product(h));
          this.slideshow.resize();
          h = document.querySelector("#SplittedImages--" + f).querySelectorAll(".splittedimages-slide--" + f);
          var l = document.querySelector(".splittedtexts-slide-" + d + "--" + f).classList[0].replace("product-slide--", ""), m = document.querySelectorAll(".product-link--button");
          null != m && m.forEach(p => {
            p.classList.remove("is-active");
          });
          "images-slide" != l && null != document.querySelector(".product-linker-" + l) && document.querySelector(".product-linker-" + l).classList.add("is-active");
          1 < h.length && null != document.querySelector("#splitted-image-" + d + "--" + f) && (h.forEach(p => {
            p.style.display = "none";
          }), document.querySelector("#splitted-image-" + d + "--" + f).style.display = "block", a(document.querySelector("#splitted-image-" + d + "--" + f), 0));
        }
      }
      this.args.fade && (this.currentSlide.classList.add("animate-out"), this.currentSlide.addEventListener("transitionend", function() {
        this.currentSlide.classList.remove("animate-out");
      }.bind(this)));
      this.args.childNav && this.childNavGoTo(d);
      if (this.args.callbacks && this.args.callbacks.onChange && "function" === typeof this.args.callbacks.onChange) {
        this.args.callbacks.onChange(d);
      }
      this.arrows && this.arrows.length && (this.arrows[0].classList.toggle("hide", 0 === d), this.arrows[1].classList.toggle("hide", d === this.childNavLinks.length - 1));
    }, afterChange:function(d) {
      this.args.fade && this.el.querySelectorAll(c.allSlides).forEach(f => {
        f.classList.remove("animate-out");
      });
      this.currentSlide = this.el.querySelector(c.currentSlide);
      this.args.childNav && this.childNavGoTo(this.slideshow.selectedIndex);
    }, destroy:function() {
      this.slideshow.destroy();
    }, reposition:function() {
      this.slideshow.reposition();
    }, _togglePause:function() {
      this.pauseBtn.classList.contains("slideshow__pause--is-paused") ? (this.pauseBtn.classList.remove("slideshow__pause--is-paused"), this.slideshow.playPlayer()) : (this.pauseBtn.classList.add("slideshow__pause--is-paused"), this.slideshow.pausePlayer());
    }, resize:function() {
      this.slideshow.resize();
      this.embeddedResize(this.slideIndex);
    }, embeddedResize:function(d) {
      if (this.el.id.includes("ProductPhotos-")) {
        var f = document.querySelector("#" + this.el.id + " .flickity-viewport"), h = this.el.id.replace("ProductPhotos-", ""), l = f.querySelectorAll(".product-single_main-slide"), m = f.querySelector(".is-selected"), p = 0;
        m.querySelector("img") ? p = m.querySelector("img").dataset.aspectratio : m.querySelector(".shopify-model-viewer-ui") && (p = m.querySelector(".shopify-model-viewer-ui").dataset.aspectratio);
        f.style.height = l[d] && 0 != l[d].offsetHeight ? l[d].offsetHeight + "px" : 200 / p + "px";
        (d = this.el.closest(".flickity-viewport")) && (m = d.querySelector(".is-selected")) && m.querySelector(".embedded-product-single__meta") && (m.querySelector(".embedded-product-single__meta"), d.style.height = m.offsetHeight + "px");
        document.querySelector("#DetailsDivider-" + h) && (h = document.querySelector("#ProductImages-" + h)) && (document.documentElement.style.setProperty("--sticky_divider-padding", 1.15 * h.offsetHeight + "px"), document.querySelector(".blurred-container").style.height = h.offsetHeight + "px");
      } else {
        this.el.id.includes("SplittedTexts-") && (f = document.querySelector("#" + this.el.id + " .flickity-viewport"), this.el.id.replace("SplittedTexts-", ""), f && (f.querySelector(".images-slide.is-selected"), f.querySelectorAll(".product-single_main-slide"), m = f.querySelector(".images-slide.is-selected"))) && (m.querySelector(".embedded-product-single__meta") && m.querySelector(".embedded-product-single__meta"), f.style.height = m.offsetHeight + "px");
      }
    }, play:function() {
      this.slideshow.playPlayer();
    }, pause:function() {
      this.slideshow.pausePlayer();
    }, goToSlide:function(d) {
      this.slideshow.select(d);
    }, setDraggable:function(d) {
      this.slideshow.options.draggable = d;
      this.slideshow.updateDraggable();
    }, initChildNav:function() {
      this.childNavLinks.forEach(d => {
        d.classList.remove("is-active");
      });
      this.childNavLinks[this.args.initialIndex].classList.add("is-active");
      this.childNavLinks.forEach((d, f) => {
        d.setAttribute("data-index", f);
        d.addEventListener("click", function(h) {
          h.preventDefault();
          this.goToSlide(this.getChildIndex(h.currentTarget));
        }.bind(this));
        d.addEventListener("focus", function(h) {
          this.goToSlide(this.getChildIndex(h.currentTarget));
        }.bind(this));
        d.addEventListener("keydown", function(h) {
          13 === h.keyCode && this.goToSlide(this.getChildIndex(h.currentTarget));
        }.bind(this));
      });
      this.arrows.length && this.arrows.forEach(d => {
        d.addEventListener("click", this.arrowClick.bind(this));
      });
    }, getChildIndex:function(d) {
      return parseInt(d.dataset.index);
    }, childNavGoTo:function(d) {
      this.childNavLinks.forEach(f => {
        f.classList.remove("is-active");
      });
      0 < this.childNavLinks.length && (d = this.childNavLinks[d], d.classList.add("is-active"), this.args.childVertical ? this.args.childNavScroller.scrollTop = d.offsetTop - 100 : this.args.childNavScroller.scrollLeft = d.offsetLeft - 100);
    }, arrowClick:function(d) {
      d.currentTarget.classList.contains("product-single__thumbnail-arrow--prev") ? this.slideshow.previous() : this.slideshow.next();
    }});
    return b;
  }();
  theme.parallaxSections = {};
  theme.Parallax = function() {
    function b(c, e) {
      this.isVisible = this.isInit = !1;
      this.container = c;
      this.image = c.querySelector(".parallax-image");
      this.namespace = e.namespace;
      this.desktopOnly = e.desktopOnly;
      this.container && this.image && (this.desktopOnly && (document.addEventListener("matchSmall", function() {
        this.destroy();
      }.bind(this)), document.addEventListener("unmatchSmall", function() {
        this.init(!0);
      }.bind(this))), this.init(this.desktopOnly));
    }
    var a = !1;
    b.prototype = Object.assign({}, b.prototype, {init:function(c) {
      this.isInit && this.destroy();
      this.isInit = !0;
      if (!c || !theme.config.bpSmall) {
        this.setSizes();
        this.scrollHandler();
        (new IntersectionObserver((g, d) => {
          g.forEach(f => {
            if (this.isVisible = f.isIntersecting) {
              window.on("scroll" + this.namespace, this.onScroll.bind(this));
            } else {
              window.off("scroll" + this.namespace);
            }
          });
        }, {rootMargin:"200px 0px 200px 0px"})).observe(this.container);
        var e = window.innerWidth;
        window.on("resize" + this.namespace, theme.Helpers.debounce(250, function() {
          window.innerWidth != e && (e = window.innerWidth, this.setSizes.bind(this));
        }.bind(this)));
        document.addEventListener("shopify:section:reorder", theme.Helpers.debounce(250, this.onReorder.bind(this)));
      }
    }, onScroll:function() {
      this.isVisible && (window.SPR && !a && (this.setSizes(), a = !0), requestAnimationFrame(this.scrollHandler.bind(this)));
    }, scrollHandler:function() {
      this.image.style.transform = "translate3d(0, " + 0.85 * (window.scrollY - this.elTop) + "px, 0)";
    }, setSizes:function() {
      this.elTop = this.container.getBoundingClientRect().top + window.scrollY;
    }, onReorder:function() {
      this.setSizes();
      this.onScroll();
    }, destroy:function() {
      this.image.style.transform = "none";
      window.off("scroll" + this.namespace);
      window.off("resize" + this.namespace);
    }});
    return b;
  }();
  theme.QtySelector = function() {
    function b(c, e) {
      this.wrapper = c;
      this.plus = c.querySelector(a.plus);
      this.minus = c.querySelector(a.minus);
      this.input = c.querySelector(a.input);
      this.remove = c.querySelector(a.remove);
      this.minValue = this.input.getAttribute("min") || 1;
      this.sectionId = this.wrapper.querySelector(".js-qty__num").id.replace("Quantity-", "");
      this.options = Object.assign({}, {namespace:null, isCart:!1, key:this.input.dataset.id}, e);
      this.init();
    }
    var a = {input:".js-qty__num", plus:".js-qty__adjust--plus", minus:".js-qty__adjust--minus", remove:".js-qty__adjust--empty"};
    b.prototype = Object.assign({}, b.prototype, {init:function() {
      this.plus.addEventListener("click", function() {
        var c = this._getQty();
        this._change(c + 1, !1);
      }.bind(this));
      this.minus.addEventListener("click", function() {
        var c = this._getQty();
        this._change(c - 1, !1);
      }.bind(this));
      this.remove && this.remove.addEventListener("click", function() {
        this._change(0, !0);
      }.bind(this));
      this.input.addEventListener("change", function(c) {
        this._change(this._getQty(), !1);
      }.bind(this));
    }, _getQty:function() {
      var c = this.input.value;
      if (parseFloat(c) != parseInt(c) || isNaN(c)) {
        c = 1;
      }
      return parseInt(c);
    }, _change:function(c, e) {
      c <= this.minValue && (c = this.minValue);
      e || (this.input.value = c);
      this.options.isCart && document.dispatchEvent(new CustomEvent("cart:quantity" + this.options.namespace, {detail:[this.options.key, c, this.wrapper]}));
      document.getElementById("CustomVariantQuantity-" + this.sectionId) && (document.getElementById("CustomVariantQuantity-" + this.sectionId).value = c);
    }});
    return b;
  }();
  theme.articleImages = function() {
    var b = document.querySelectorAll(".rte--indented-images");
    b.length && b.forEach(a => {
      a.querySelectorAll("img").forEach(c => {
        var e = c.getAttribute("style");
        e && "float: none;" != e || c.width < a.offsetWidth && c.classList.add("rte__no-indent");
      });
    });
  };
  theme.customerTemplates = function() {
    function b() {
      document.getElementById("RecoverPasswordForm").classList.toggle("hide");
      document.getElementById("CustomerLoginForm").classList.toggle("hide");
    }
    function a(c) {
      var e = c.classList.contains("hide");
      e ? document.querySelector(".section-header__title").innerHTML = theme.strings.addressTitle : document.querySelector(".section-header__title").innerHTML = theme.strings.addressNew;
      document.querySelectorAll(".js-address-grid").forEach(g => {
        e ? g.classList.remove("hide") : g.classList.add("hide");
      });
    }
    "#recover" === window.location.hash && b();
    (function() {
      var c = document.getElementById("RecoverPassword");
      c && c.addEventListener("click", function(e) {
        e.preventDefault();
        b();
      });
      (c = document.getElementById("HideRecoverPasswordLink")) && c.addEventListener("click", function(e) {
        e.preventDefault();
        b();
      });
    })();
    document.querySelector(".reset-password-success") && document.getElementById("ResetSuccess").classList.remove("hide");
    (function() {
      var c = document.getElementById("AddressNewForm"), e = document.querySelectorAll(".js-address-form");
      c && e.length && (setTimeout(function() {
        document.querySelectorAll(".js-address-country").forEach(g => {
          new Shopify.CountryProvinceSelector(g.dataset.countryId, g.dataset.provinceId, {hideElement:g.dataset.provinceContainerId});
        });
      }, 1000), document.querySelectorAll(".address-new-toggle").forEach(g => {
        g.addEventListener("click", function(d) {
          document.getElementById("AddressNewForm").classList.toggle("hide");
          a(document.getElementById("AddressNewForm"));
        });
      }), document.querySelectorAll(".address-edit-toggle").forEach(g => {
        g.addEventListener("click", function(d) {
          d = d.currentTarget.dataset.formId;
          document.getElementById("EditAddress_" + d).classList.toggle("hide");
          document.querySelector(".section-header__title").innerHTML = theme.strings.addressEdit;
          a(document.getElementById("EditAddress_" + d));
        });
      }), document.querySelectorAll(".address-delete").forEach(g => {
        g.addEventListener("click", function(d) {
          var f = d.currentTarget.dataset.formId;
          confirm(d.currentTarget.dataset.confirmMessage || "Are you sure you wish to delete this address?") && Shopify && Shopify.postLink("/account/addresses/" + f, {parameters:{_method:"delete"}});
        });
      }));
    })();
  };
  window.onpageshow = function(b) {
    b.persisted && (document.body.classList.remove("unloading"), document.querySelectorAll(".cart__checkout").forEach(a => {
      a.classList.remove("btn--loading");
    }));
    document.querySelectorAll(".image-grid-item--loader").forEach(a => {
      a.classList.remove("loading", "loading--delayed");
      a.classList.add("loaded");
    });
  };
  theme.pageTransitions = function() {
    "true" === document.body.dataset.transitions && (navigator.userAgent.match(/Version\/[\d\.]+.*Safari/) && document.querySelectorAll("a").forEach(b => {
      window.setTimeout(function() {
        document.body.classList.remove("unloading");
      }, 1200);
    }), document.querySelectorAll('a[href^="mailto:"], a[href^="#"], a[target="_blank"], a[href*="youtube.com/watch"], a[href*="youtu.be/"], a[download]').forEach(b => {
      b.classList.add("js-no-transition");
    }), document.querySelectorAll("a:not(.js-no-transition)").forEach(b => {
      b.addEventListener("click", function(a) {
        if (a.metaKey) {
          return !0;
        }
        a.preventDefault();
        document.body.classList.add("unloading");
        var c = b.getAttribute("href");
        window.setTimeout(function() {
          location.href = c;
        }, 50);
      });
    }), document.querySelectorAll("a.mobile-nav__link").forEach(b => {
      b.addEventListener("click", function() {
        theme.MenuDrawer.close();
      });
    }));
  };
  theme.SlideshowSection = function() {
    function b(a) {
      this.container = a;
      var c = a.getAttribute("data-section-id");
      this.slideshow = a.querySelector("#Slideshow-" + c);
      this.namespace = "." + c;
      this.slideshow && (a = a.parentElement, [].indexOf.call(a.parentElement.children, a), this.init());
    }
    b.prototype = Object.assign({}, b.prototype, {init:function() {
      var a = this.slideshow.querySelectorAll(".slideshow__slide");
      this.slideshow.querySelectorAll(".image-grid-item--loader").forEach(c => {
        c.classList.remove("loading", "loading--delayed");
        c.classList.add("loaded");
      });
      a.forEach(c => {
        c.classList.remove("loading", "loading--delayed");
        c.classList.add("loaded");
      });
      1 < a.length ? (a = {prevNextButtons:!1, pageDots:this.slideshow.hasAttribute("data-slider-dots"), fade:!0, setGallerySize:!1, initialIndex:this.initialIndex, pauseAutoPlayOnHover:!1, autoPlay:0 < parseInt(this.slideshow.dataset.speed) ? parseInt(this.slideshow.dataset.speed) : !1}, this.flickity = new theme.Slideshow(this.slideshow, a), this.siteNavBtns = this.container.querySelectorAll(".site-nav__dropdown-link"), this.flickity.el.querySelector(".dot") && this.flickity.el.querySelectorAll(".dot").forEach((c, 
      e) => {
        0 == e && this.container.querySelector(".background-media-text__overlay .site-nav__dropdown-link") && this.container.querySelector(".background-media-text__overlay .site-nav__dropdown-link").classList.add("is-active");
        var g = this.siteNavBtns[e];
        if (g) {
          g = g.textContent || g.innerText;
          var d = document.createElement("div");
          d.innerHTML = `<button class="btn btn--inverse small--hide">${g}</button>`;
          c.appendChild(d.firstElementChild);
          c.querySelector(".btn").addEventListener("click", function() {
            this.flickity.goToSlide(e);
            this.flickity.pause();
          }.bind(this));
          0 < this.siteNavBtns.length && this.siteNavBtns[e].addEventListener("click", function() {
            this.flickity.slideIndex == e && "" != this.siteNavBtns[e].dataset.url ? window.location.href = this.siteNavBtns[e].dataset.url : (this.flickity.goToSlide(e), this.flickity.pause());
          }.bind(this));
        }
      })) : a[0].classList.add("is-selected");
      this.container.hasAttribute("data-parallax") && this.container.querySelectorAll(".parallax-container").forEach(function(c, e) {
        new theme.Parallax(c, {namespace:this.namespace + "-parallax-" + e});
      }.bind(this));
    }, forceReload:function() {
      this.onUnload();
      this.init();
    }, onUnload:function() {
      this.flickity && "function" === typeof this.flickity.destroy && this.flickity.destroy();
    }, onDeselect:function() {
      this.flickity && "function" === typeof this.flickity.play && this.flickity.play();
    }, onBlockSelect:function(a) {
      a = this.slideshow.querySelector(".slideshow__slide--" + a.detail.blockId);
      a = parseInt(a.dataset.index);
      this.flickity && "function" === typeof this.flickity.pause ? (this.flickity.goToSlide(a), this.flickity.pause()) : (this.initialIndex = a, setTimeout(function() {
        this.flickity && "function" === typeof this.flickity.pause && this.flickity.pause();
      }.bind(this), 1000));
    }, onBlockDeselect:function() {
      this.flickity && "function" === typeof this.flickity.play && this.flickity.args.autoPlay && this.flickity.play();
    }});
    return b;
  }();
  theme.BackgroundImage = function() {
    function b(a) {
      this.container = a;
      this.container.querySelectorAll(".image-grid-item--loader").forEach(c => {
        c.classList.remove("loading", "loading--delayed");
        c.classList.add("loaded");
      });
      a && (this.namespace = "." + a.getAttribute("data-section-id"), theme.initWhenVisible({element:this.container, callback:this.init.bind(this)}));
    }
    b.prototype = Object.assign({}, b.prototype, {init:function() {
      if (this.container.dataset && this.container.dataset.parallax) {
        var a = this.container.querySelector(".parallax-container");
        theme.parallaxSections[this.namespace] = new theme.Parallax(a, {namespace:this.namespace, desktopOnly:!0});
      }
    }, onUnload:function(a) {
      this.container && (theme.parallaxSections[this.namespace] && "function" === typeof theme.parallaxSections[this.namespace].destroy && theme.parallaxSections[this.namespace].destroy(), delete theme.parallaxSections[this.namespace]);
    }});
    return b;
  }();
  theme.TabSwitcher = function() {
    function b(c) {
      this.container = c;
      this.sectionId = this.container.getAttribute("data-section-id");
      this.slideshows = c.querySelectorAll(a.slider);
      this.namespace = ".switcher-" + this.sectionId;
      this.showArrows = this.container.getAttribute("data-show-arrows");
      this.flickity = {};
      this.activeIndex = 0;
      this.container.querySelectorAll(".image-grid-item--loader").forEach(e => {
        e.classList.remove("loading", "loading--delayed");
        e.classList.add("loaded");
      });
      theme.initWhenVisible({element:this.container, callback:this.init.bind(this), threshold:300});
    }
    var a = {trigger:".tab-switcher__trigger", collection:".tab-switcher__collection", slider:".tab-switcher__slider", wrapper:".collection-slider-wrapper"};
    b.prototype = Object.assign({}, b.prototype, {init:function() {
      this.container.querySelectorAll(a.trigger).forEach(e => {
        e.on("click", this.switch.bind(this));
      });
      if ("slider" == this.container.getAttribute("data-style")) {
        var c = 400;
        null != this.container.querySelectorAll(".grid-product")[1] && (c = this.container.querySelectorAll(".grid-product")[1].offsetWidth);
        this.container.querySelectorAll(a.collection).forEach(e => {
          var g = e.querySelector(a.slider);
          g && (new SimpleBar(g, {autoHide:!1})).getScrollElement().addEventListener("scroll", function(d) {
            const {scrollWidth:f, scrollLeft:h, clientWidth:l} = d.target;
            f - Math.round(h) - 4 <= l ? this.container.querySelector(".flickity-next").classList.add("hide") : 5 >= Math.round(h) ? this.container.querySelector(".flickity-previous").classList.add("hide") : (this.container.querySelector(".flickity-next").classList.remove("hide"), this.container.querySelector(".flickity-previous").classList.remove("hide"));
          }.bind(this));
          "true" == this.showArrows && (e.querySelector(".flickity-next").addEventListener("click", function(d) {
            d = g.querySelector(".simplebar-content-wrapper");
            var f = d.pageXOffset || d.scrollLeft;
            f += c;
            d.scrollTo({left:f, behavior:"smooth"});
          }.bind(this)), e.querySelector(".flickity-previous").addEventListener("click", function(d) {
            d = g.querySelector(".simplebar-content-wrapper");
            var f = d.pageXOffset || d.scrollLeft;
            f -= c;
            d.scrollTo({left:f, behavior:"smooth"});
          }.bind(this)));
        });
      }
    }, scrollHandler:function(c) {
    }, switch:function(c) {
      c.preventDefault();
      var e = c.currentTarget.getAttribute("data-controls");
      e = document.getElementById(e);
      c.currentTarget.classList.contains("tab-switcher__trigger--all") ? this.container.querySelectorAll(a.collection).forEach(g => {
        g.classList.remove("hide");
      }) : (this.activeIndex = parseInt(e.dataset.index), this.container.querySelectorAll(a.collection).forEach(g => {
        g.classList.add("hide");
      }), e.classList.remove("hide"), this.flickity[this.activeIndex] && "function" === typeof this.flickity[this.activeIndex].resize && this.flickity[this.activeIndex].resize());
      this.container.querySelectorAll(a.trigger).forEach(g => {
        g.classList.remove("is-active");
      });
      c.currentTarget.classList.add("is-active");
    }, destroy:function() {
      this.flickity && "function" === typeof this.flickity.destroy && this.flickity.destroy();
    }, onUnload:function() {
      this.destroy();
    }});
    return b;
  }();
  theme.isStorageSupported = function(b) {
    if (window.self !== window.top) {
      return !1;
    }
    if ("session" === b) {
      var a = window.sessionStorage;
    }
    "local" === b && (a = window.localStorage);
    try {
      return a.setItem("test", "1"), a.removeItem("test"), !0;
    } catch (c) {
      return !1;
    }
  };
  theme.Splittedtexts = function() {
    function b(c) {
      this.container = c;
      this.contentSize = parseInt(c.getAttribute("data-content-size"));
      this.section_id = c.getAttribute("data-section-id");
      this.slideshow = c.querySelector("#SplittedTexts--" + this.section_id);
      this.namespace = ".splittedtext-" + this.section_id;
      this.container.querySelectorAll(".image-grid-item--loader").forEach(e => {
        e.classList.remove("loading", "loading--delayed");
        e.classList.add("loaded");
      });
      this.slideshow && theme.initWhenVisible({element:this.container, callback:this.init.bind(this), threshold:600});
    }
    var a = {adaptiveHeight:!0, pageDots:!0, autoPlay:!1, prevNextButtons:!0, pauseAutoPlayOnHover:!0, watchCSS:!1};
    b.prototype = Object.assign({}, b.prototype, {init:function() {
      a.wrapAround = !0;
      a.watchCSS = "true" == this.slideshow.dataset.watchcss ? !0 : !1;
      0 < parseInt(this.slideshow.dataset.autoplay) ? a.autoPlay = parseInt(this.slideshow.dataset.autoplay) : a.autoPlay = !1;
      a.pageDots = 1 >= this.slideshow.dataset.count ? !1 : !0;
      a.prevNextButtons = "true" == this.slideshow.dataset.buttons ? !0 : !1;
      this.flickity = new theme.Slideshow(this.slideshow, a);
      var c = document.querySelector("#ProductSection-" + this.section_id + 0);
      c && "false" == c.dataset.generated && (c.dataset.generated = "true", this.Product = new theme.Product(c));
      var e = document.querySelector("#SplittedImages--" + this.section_id).querySelectorAll(".splittedimages-slide--" + this.section_id);
      if (0 < e.length && void 0 != this.flickity.currentSlide) {
        var g = this.flickity.currentSlide.classList[0].replace("product-slide--", "");
        e.forEach((f, h) => {
          var l = this.flickity;
          f = document.querySelectorAll('[id^="SlideSelector-' + h + "--" + this.section_id + '"]');
          0 < f.length && f.forEach(m => {
            m.getAttribute("data-product-selector") == g && m.classList.add("is-active");
            m.addEventListener("click", function(p) {
              p = p.target.getAttribute("data-product-selector");
              p = document.querySelector(".product-slide--" + p);
              null != p && l.goToSlide(parseInt(p.getAttribute("data-index")));
            });
          });
        });
      }
      if (0 < e.length && "true" == this.slideshow.dataset.watchcss) {
        var d = this.slideshow.querySelectorAll(".list-item--btn");
        this.selectedIndex = 0;
        0 < parseInt(this.slideshow.dataset.autoplay) && this.initSlider(!1, d);
        d.forEach((f, h) => {
          f.addEventListener("click", function() {
            this.initSlider(!0, d);
            this.selectedIndex = parseInt(f.dataset.index) - 1;
            d.forEach(l => {
              l.classList.remove("is-selected");
            });
            f.classList.add("is-selected");
            e.forEach(l => {
              l.style.display = "none";
            });
            document.querySelector("#splitted-image-" + h + "--" + this.section_id).style.display = "block";
          }.bind(this));
        });
      }
    }, forceReload:function() {
      this.onUnload();
      this.init();
      this._setButtons();
    }, onUnload:function() {
      this.flickity && "function" === typeof this.flickity.destroy && this.flickity.destroy();
    }, onDeselect:function() {
      this.flickity && "function" === typeof this.flickity.play && this.flickity.play();
    }, onBlockSelect:function(c) {
      c = this.slideshow.querySelector(".splittedtexts-slide--" + c.detail.blockId);
      c = parseInt(c.dataset.index);
      this.flickity && "function" === typeof this.flickity.pause && (this.flickity.goToSlide(c), this.flickity.pause());
    }, onBlockDeselect:function() {
      this.flickity && "function" === typeof this.flickity.play && this.flickity.play();
    }, onListSelect:function() {
    }, initSlider:function(c, e) {
      c ? clearInterval(this.interval) : this.interval = setInterval(function() {
        document.querySelector("#splitted-image-" + this.selectedIndex + "--" + this.section_id).style.display = "none";
        this.container.querySelector(".list-item--btn--" + this.selectedIndex) && (this.container.querySelector(".list-item--btn--" + this.selectedIndex).classList.remove("is-selected"), this.selectedIndex += 1, e.length == this.selectedIndex && (this.selectedIndex = 0), this.container.querySelector(".list-item--btn--" + this.selectedIndex).classList.add("is-selected"));
        document.querySelector("#splitted-image-" + this.selectedIndex + "--" + this.section_id).style.display = "block";
      }.bind(this), 5000);
    }});
    return b;
  }();
  theme.Message = function() {
    function b(a) {
      this.container = a;
      this.sectionId = a.getAttribute("data-section-id");
      this.submitBtn = this.container.querySelector("[data-submit-form]");
      this.init();
    }
    b.prototype = Object.assign({}, b.prototype, {init:function() {
      this.initImagePicker();
      this.initQtySelector();
    }, initQtySelector:function() {
      this.container.querySelectorAll(".js-qty__wrapper").forEach(a => {
        new theme.QtySelector(a, {namespace:".product", sectionId:this.sectionId});
      });
    }, addItemFromForm:function(a, c, e) {
      let g = ["image/jpeg", "image/jpg", "image/png"];
      var d = a.querySelector(".grid__image--file");
      e.classList.add("disabled");
      a.classList.add("btn--loading");
      a.querySelector(".grid__image").style.opacity = 0.2;
      let f = new FileReader();
      f.addEventListener("loadend", () => {
        var h = f.result.split("base64,")[1];
        let l = d.files[0].type;
        1800000 < d.files[0].size ? (a.querySelector(".grid__image").classList.add("hide"), a.querySelector(".cart__remove-wrapper").classList.add("hide"), a.querySelector(".grid__text").classList.remove("hide"), a.querySelector(".grid__image").src = "", a.classList.remove("active"), a.classList.remove("btn--loading"), alert("File is too big!")) : (h = {base64:h, type:l, name:d.files[0].name, createevent:!0}, g.includes(l) && (a.querySelector(".grid__image").classList.remove("hide"), a.querySelector(".grid__text").classList.add("hide"), 
        a.querySelector(".grid__image").src = f.result), fetch(c, {method:"POST", body:JSON.stringify(h)}).then(m => m.text()).then(function(m) {
          a.querySelector(".grid__text").parentElement.dataset.id = d.files[0].name;
          a.querySelector(".cart__remove-wrapper").classList.remove("hide");
          a.querySelector(".grid__image").style.opacity = 1;
          a.classList.remove("btn--loading");
          e.classList.remove("disabled");
          var p = encodeURI(m).replace("=download", "");
          m = this.container.querySelector(".grid__image--url");
          "" != m.value && (p = m.value + " " + p, m.value = p);
          this.container.querySelector(".grid__image--url").setAttribute("value", p);
          this.container.querySelector(".grid__image--url").inoutHTML = p;
        }.bind(this)));
      });
      f.readAsDataURL(d.files[0]);
    }, initImagePicker:function() {
      this.container.querySelectorAll(".grid__item-draggable").forEach(a => {
        const c = a.parentElement.dataset.script;
        a.querySelector(".grid__text");
        const e = a.querySelector(".grid__text"), g = a.querySelector(".cart__remove-wrapper"), d = a.querySelector(".grid__image--file");
        e.onclick = () => {
          d.click();
        };
        d.addEventListener("change", function() {
          a.classList.add("active");
          this.addItemFromForm(a, c, this.submitBtn);
        }.bind(this));
        a.addEventListener("dragover", f => {
          f.preventDefault();
          a.classList.add("active");
        });
        a.addEventListener("dragleave", () => {
          a.classList.remove("active");
        });
        a.addEventListener("drop", f => {
          f.preventDefault();
          a.querySelector("input").files = f.dataTransfer.files;
          this.addItemFromForm(a, c, this.submitBtn);
        });
        g.onclick = () => {
          var f = a.querySelector(".grid__text").parentElement.dataset.id;
          f && (a.querySelector(".grid__image").classList.add("hide"), a.querySelector(".cart__remove-wrapper").classList.add("hide"), a.querySelector(".grid__text").classList.remove("hide"), a.querySelector(".grid__image").src = "", a.classList.remove("active"), a.classList.remove("btn--loading"), d.value = null, fetch(c, {method:"POST", body:JSON.stringify({name:f, createevent:!1})}).then(h => h.text()).then(function(h) {
            a.querySelector("input").value = h;
          }.bind(this)));
        };
      });
    }});
    return b;
  }();
  theme.isSessionStorageSupported = function() {
    if (window.self !== window.top) {
      return !1;
    }
    var b = window.sessionStorage;
    try {
      return b.setItem("test", "1"), b.removeItem("test"), !0;
    } catch (a) {
      return !1;
    }
  };
  theme.config.hasSessionStorage = theme.isSessionStorageSupported();
  theme.config.hasLocalStorage = theme.isStorageSupported("local");
  if (theme.config.hasLocalStorage) {
    var r = window.localStorage.getItem("recently-viewed");
    r && (theme.recentlyViewedIds = JSON.parse(r));
  }
  theme.config.bpSmall = matchMedia(theme.config.mediaQuerySmall).matches;
  matchMedia(theme.config.mediaQuerySmall).addListener(function(b) {
    b.matches ? (theme.config.bpSmall = !0, document.dispatchEvent(new CustomEvent("matchSmall"))) : (theme.config.bpSmall = !1, document.dispatchEvent(new CustomEvent("unmatchSmall")));
  });
  theme.sizeDrawer = function() {
    var b = document.getElementById("HeaderWrapper").offsetHeight;
    document.documentElement.style.setProperty("--maxDrawerHeight", `${window.innerHeight - b}px`);
  };
  theme.initGlobals = function() {
    theme.collapsibles.init();
  };
  (function(b) {
    "loading" != document.readyState ? b() : document.addEventListener("DOMContentLoaded", b);
  })(function() {
    theme.sections = new theme.Sections();
    theme.sections.register("slideshow-section", theme.SlideshowSection);
    theme.sections.register("tab-switcher", theme.TabSwitcher);
    theme.sections.register("background-image", theme.BackgroundImage);
    theme.sections.register("splittedtexts", theme.Splittedtexts);
    theme.sections.register("message", theme.Message);
    theme.initGlobals();
    slate.rte();
    theme.articleImages();
    theme.settings.isCustomerTemplate && theme.customerTemplates();
    theme.pageTransitions();
    document.dispatchEvent(new CustomEvent("page:loaded"));
  });
})();